import React, { useState } from 'react';
import { Globe2, Radio, AlertTriangle, ClipboardCheck, FileDown, LayoutGrid, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card, PageHeader } from '../ui';
import { DOC_URL } from './parts';
import { LAYOUTS } from './layouts';

import TravelRiskMap from './TravelRiskMap';
export { LEVELS, ScoreBadge, scoreColor, DOC_URL } from './parts';

const KEY = 'bond_travel_layout';

function Kpi({ icon: Icon, label, value, testid }) {
  return (
    <Card className="p-5 flex items-center gap-4">
      <span className="w-10 h-10 grid place-items-center rounded-sm bg-[#D4AF37]/10"><Icon size={18} className="text-[#D4AF37]" /></span>
      <div><p className="font-heading text-2xl text-[#F2F2F2] leading-none" data-testid={testid}>{value}</p><p className="text-xs text-[#8A8F97] mt-1">{label}</p></div>
    </Card>
  );
}

function LayoutPicker({ value, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-6" data-testid="travel-layout-picker">
      <span className="text-xs text-[#8A8F97] inline-flex items-center gap-1.5 mr-1"><LayoutGrid size={14} />Layout</span>
      {LAYOUTS.map(([k, label]) => (
        <button key={k} onClick={() => onChange(k)} className={`h-8 px-3 text-xs rounded-sm border transition-colors ${value === k ? 'bg-[#D4AF37] border-[#D4AF37] text-[#050505] font-semibold' : 'border-[#1F242C] text-[#8A8F97] hover:text-[#F2F2F2]'}`} data-testid={`travel-layout-${k}`}>{label}</button>
      ))}
    </div>
  );
}

export default function TravelDashboard({ countries, news, changes = [], onOpen }) {
  const [layout, setLayout] = useState(() => localStorage.getItem(KEY) || 'atlante');
  const pick = (k) => { localStorage.setItem(KEY, k); setLayout(k); };
  const View = (LAYOUTS.find(([k]) => k === layout) || LAYOUTS[0])[2];
  const high = countries.filter((c) => c.farnesina_level >= 3).length;
  return (
    <div data-testid="travel-dashboard">
      <PageHeader kicker="Sicurezza in viaggio" title="Travel Security">
        <a href={DOC_URL} download className="h-10 px-4 flex items-center gap-2 text-sm border border-[#1F242C] rounded-sm text-[#A3A3A3] hover:text-[#D4AF37]" data-testid="travel-doc-link"><FileDown size={15} />Obblighi di legge (PDF)</a>
        <Link to="/portal/travel-security/compliance" className="h-10 px-4 flex items-center gap-2 text-sm bg-[#D4AF37] text-[#050505] font-semibold rounded-sm" data-testid="travel-compliance-link"><ClipboardCheck size={15} />Compliance e trasferte</Link>
        <Link to="/portal/richieste/travel_protection" className="h-10 px-4 flex items-center gap-2 text-sm border border-[#D4AF37] text-[#D4AF37] rounded-sm" data-testid="travel-protection-link"><ShieldCheck size={15} />Servizi di sicurezza</Link>
      </PageHeader>
      <TravelRiskMap />
      <LayoutPicker value={layout} onChange={pick} />
      <div className="grid sm:grid-cols-3 gap-4 mb-4">
        <Kpi icon={Globe2} label="Paesi con scheda informativa" value={countries.length} testid="travel-kpi-countries" />
        <Kpi icon={Radio} label="Avvisi dell'ultima ora" value={news.length} testid="travel-kpi-news" />
        <Kpi icon={AlertTriangle} label="Paesi con viaggio sconsigliato o da valutare" value={high} testid="travel-kpi-high" />
      </div>
      <View countries={countries} news={news} changes={changes} onOpen={onOpen} />
      <p className="text-xs text-[#5A5F67] mt-4">Fonti: Viaggiare Sicuri, Unità di Crisi del Ministero degli Affari Esteri e della Cooperazione Internazionale · Indice BOND: media con lo stesso peso di 8 fonti istituzionali (Italia, USA, Canada, Regno Unito, Germania, Israele, Giappone, Nuova Zelanda) · Aggiornamenti: Farnesina ogni 3 ore, avvisi dei governi esteri ogni 6 ore, notizie "Ultima ora" ogni 30 minuti.</p>
    </div>
  );
}
